import React, {createRef, useCallback, useEffect, useState} from "react";
import Checkbox from "../../atoms/checkbox/checkbox.component.js";
import HelpIcon from "../help-icon/help-icon.component.js";
import {RenderGroup} from "./checkbox-group.component.js";
function useGroupSelector() {
  return useCallback((contents) => {
    let checks = 0;
    let allCount = 0;
    contents.forEach((content) => {
      allCount++;
      if (content.checked) {
        checks++;
      }
    });
    return [allCount, checks];
  }, []);
}
export function useGroupGenerator({
  title,
  contents,
  onChange,
  setContentsState
}) {
  const [generatedContent, setGeneratedContent] = useState([]);
  const [refs, setRefs] = useState([]);
  const getAllSelects = useGroupSelector();
  const getIsAllChecked = useCallback((cnts) => {
    const [all, checks] = getAllSelects(cnts);
    return all === checks;
  }, [getAllSelects]);
  const [isAllChecked, setIsAllChecked] = useState(() => getIsAllChecked(contents));
  useEffect(() => {
    setIsAllChecked(getIsAllChecked(contents));
  }, [contents, getIsAllChecked]);
  const _onChange = useCallback((checked, {
    text,
    name
  }) => {
    const newContents = [...contents].map((content) => {
      if (text && content.text === text || name && content.name === name) {
        return {
          ...content,
          checked
        };
      }
      return {
        ...content
      };
    });
    setContentsState(newContents);
    onChange({
      title,
      contents: newContents
    });
  }, [contents, onChange, setContentsState, title]);
  useEffect(() => {
    let checkboxRefArray = [];
    const genContent = contents.map((content) => {
      const {
        checked,
        name,
        text,
        help,
        readOnly,
        required,
        conditionShow
      } = content;
      const checkboxRef = /* @__PURE__ */ createRef();
      checkboxRefArray = [...checkboxRefArray, checkboxRef];
      const show = conditionShow ? conditionShow(contents) : true;
      const contentCheckbox = /* @__PURE__ */ React.createElement(Checkbox, {
        ref: checkboxRef,
        key: `${title}__${text}`,
        name,
        checked,
        required,
        readOnly,
        onChange: (chkd) => _onChange(chkd, content)
      }, text);
      if (!show && checked) {
        _onChange(false, content);
      }
      return help ? /* @__PURE__ */ React.createElement(HelpIcon, {
        key: `${title}__h__${text}`,
        text: help
      }, contentCheckbox) : show ? contentCheckbox : "";
    });
    setRefs(checkboxRefArray);
    setGeneratedContent(genContent);
  }, [_onChange, contents, title]);
  return {
    generatedContent,
    refs,
    isAllChecked: [isAllChecked]
  };
}
export function useMainGenerator({
  items,
  setItemsState
}) {
  const [generatedContent, setGeneratedContent] = useState([]);
  const [refs, setRefs] = useState([]);
  const getAllSelects = useGroupSelector();
  const getIsAllChecked = useCallback((its) => {
    let checks = 0;
    let allCount = 0;
    its.forEach(({
      contents
    }) => {
      const [all, check] = getAllSelects(contents);
      allCount += all;
      checks += check;
    });
    return checks === allCount;
  }, [getAllSelects]);
  const [isAllChecked, setIsAllChecked] = useState(() => getIsAllChecked(items));
  useEffect(() => {
    setIsAllChecked(getIsAllChecked(items));
  }, [getIsAllChecked, items]);
  const onChange = useCallback(({
    contents,
    title
  }) => {
    const newItemsState = items.map((it) => {
      if (it.title === title) {
        return {
          ...it,
          contents
        };
      }
      return it;
    });
    setIsAllChecked(getIsAllChecked(newItemsState));
    setItemsState(newItemsState);
  }, [getIsAllChecked, items, setItemsState]);
  useEffect(() => {
    let groupsRefArray = [];
    const genContent = items.map(({
      contents,
      title
    }) => {
      const renderRef = /* @__PURE__ */ createRef();
      groupsRefArray = [...groupsRefArray, renderRef];
      return /* @__PURE__ */ React.createElement(RenderGroup, {
        ref: renderRef,
        key: title,
        contents,
        title,
        onChange
      });
    });
    setRefs(groupsRefArray);
    setGeneratedContent(genContent);
  }, [items, onChange]);
  return {
    generatedContent,
    refs,
    isAllChecked: [isAllChecked, setIsAllChecked]
  };
}
